var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowCenteredLeft = function SvgArrowCenteredLeft(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 44 44",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#arrow-centered-left_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFC",
    fillRule: "evenodd",
    d: "M18.68 22.764h8.526a.78.78 0 1 0 0-1.56H18.68l2.769-2.77a.78.78 0 0 0-1.103-1.103l-4.101 4.101a.78.78 0 0 0 0 1.104l4.1 4.1a.78.78 0 0 0 1.104-1.103z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "arrow-centered-left_svg__a",
    width: 104,
    height: 104,
    x: -30,
    y: -30,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_36"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_1_36",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowCenteredLeft);
export default ForwardRef;